export interface HeaderSearchResultItem {
	id: number | string;
	title: string;
	description?: string;
	url?: string;
	slug?: string;
}

export const headerSearchCategories = ['Stocks', 'Blogs', 'Circulars', 'News', 'Articles'] as const;

export type HeaderSearchCategory = (typeof headerSearchCategories)[number];

export interface NewsApiItem {
	guid: string | number;
	title: string;
	description?: string;
}

export interface NewsApiResponse {
	items?: NewsApiItem[];
}

export interface ArticleApiItem {
	_id: string | number;
	article?: {
		title: string;
		description?: string;
	};
}

export interface WpPostItem {
	id: string | number;
	title?: { rendered: string };
	link: string;
	slug?: string;
}

export interface StockSearchItem {
	Slug: string;
	CompanyName: string;
}

export interface StockSearchApiResponse {
	data?: StockSearchItem[];
}
